import {styled} from "@mui/material/styles";

export const BlockWrapper = styled('div', {shouldForwardProp: (propName) => propName !== 'active'})<{
	active?: boolean
}>(({theme, active}) => ({
	borderRadius: theme.shape.borderRadius,
	border: `2px solid`,
	borderColor: active ? theme.palette.primary.main : 'transparent',
	backgroundColor: theme.palette.background.paper,
	padding: '11px 10px',
	display: 'inline-flex',
	color: theme.palette.text.primary,
	alignItems: 'center',
	minWidth: '200px',
	minHeight: 160,
	height: '100%',
	paddingTop: '40px',
	width: 'auto',
	textAlign:'center',
	justifyContent: 'flex-start',
	cursor: "pointer",
	position: 'relative',
	flexDirection: 'column',
	transition: 'box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.1s cubic-bezier(0.4, 0, 0.2, 1)',
	userSelect: 'none',
	boxShadow: active ? '0px 5px 7px 0px #5243C23B' : 'none',
	"&:hover": {
		boxShadow: '0px 5px 7px 0px #5243C23B',
	}
}))
